import React, { FC, useEffect, useState } from "react";
import { DocumentType, LoadingStatus } from "../../../../@types/enumsGlobal";
import { DefaultGrid } from "../../../../components/grids/default/defaultGrid";
import { PluginWrapper, ToolbarWrapper } from "../../../../components/plugins";
import { Spinner } from "../../../../components/spiner/Spinner";
import useGridFilter from "../../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import { useDetailsTabsPanel } from "../../../../system/hooks/useTabsPanel";
import { TabsPanel } from "../../../../components/tabs";
import classNames from "classnames";
import tabsStyles from './../../../../pages/styles/homePage.module.scss'
import { usePluginContext } from "../../../../system/providers/plugin";
import styles from '../styles/pricingPriceCalcSchemaTypeGrid.module.scss'
import { IPricingPriceCalcSchemaTypeDTO, IPricingPriceCalcSchemaTypeViewDTO } from "../../../../libs/coreapi-dto/dirs/pricingPriceCalcSchemaType";
import { PricingPriceCalcSchemaTypeDataProvider } from "../../../../Services/DataProviders/PricingPriceCalcSchemaTypeDataProvider";
import PricingAdpriceScaleTypeCreatorModal from "../../PricingAdpriceScaleType/selectorModal/PricingAdpriceScaleTypeCreatorModal";
import { DefaultPricingTypeCommandsPanel } from "../../../../components/commandsPanels/DefaultPricingTypeCommandsPanel";
import { IPricingAdpriceScaleTypeViewDTO } from "../../../../libs/coreapi-dto/dirs/pricingAdpriceScaleType";

interface IModalStateProps {
    isOpen: boolean,
    modalData: IPricingPriceCalcSchemaTypeDTO | undefined,
    variant: "create" | "edit" | "copy";
    selectedCalcSchemaTypeObject?: IPricingAdpriceScaleTypeViewDTO;
}

export const PricingPriceCalcSchemaTypeGrid: FC<IGridProps> = (props) => {
    const appCtx = useAppContext();
    const pluginCtx = usePluginContext();
    const pricingPriceCalcSchemaTypeDP = new PricingPriceCalcSchemaTypeDataProvider(appCtx.coreApiService);

    const [data, setData] = useState<IPricingPriceCalcSchemaTypeViewDTO[]>([]);
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>();
    const [totalCount, setTotalCount] = useState(0);
    const [viewState, setViewState] = useState<GridStateType>("view");
    const [gridFilter, dispatchGridFilter] = useGridFilter(props.baseGridFilter);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [isSubmitting, setIsSubmitting] = useState<boolean>(true);
    const [detailsTabsPanel, dispatchDetailsTabsPanel] = useDetailsTabsPanel(props.plugin.mnemocode);
    const [dataCache, setDataCache] = useState<Map<string, IPricingPriceCalcSchemaTypeViewDTO>>(new Map());
    const selectedCalcSchemaTypeObject = data.find((item) => item.idGlobal === selectedItem?.idGlobal) || (selectedItem ? dataCache.get(selectedItem.idGlobal as string) : undefined);
    
    useEffect(() => {
        getView();
    }, [gridFilter])

    const [modalState, setModalState] = useState<IModalStateProps>({
        isOpen: false,
        modalData: undefined,
        variant: 'create',
        selectedCalcSchemaTypeObject: selectedCalcSchemaTypeObject
    });

    const getView = () => {
        setSelectedItem(undefined)
        setIsSubmitting(true)
        pricingPriceCalcSchemaTypeDP.getView(gridFilter, async (data, totalCount) => {
            setData(data)
            setTotalCount(totalCount)
            setLoadingStatus(LoadingStatus.Completed)
            setIsSubmitting(false)
        })
    }


    return (
        <>
            <PluginWrapper>
                <ToolbarWrapper className={styles.toolbarPosition}>
                    <DefaultPricingTypeCommandsPanel
                        dataProvider={pricingPriceCalcSchemaTypeDP}
                        selectedItem={selectedItem}
                        getView={getView}
                        setModalState={setModalState}
                        dispatchGridFilter={dispatchGridFilter}
                        pluginSettings={props.plugin.permission}
                    />
                </ToolbarWrapper>
                {
                    isSubmitting ? <Spinner />
                        :
                        <DefaultGrid
                            showQuantity
                            gridId={props.gridId}
                            data={data}
                            loadingStatus={loadingStatus}
                            setLoadingStatus={setLoadingStatus}
                            separator
                            singleDirectory
                            totalCount={totalCount}
                            filter={gridFilter}
                            dataProvider={pricingPriceCalcSchemaTypeDP}
                            plugin={props.plugin}
                            selectedItem={selectedItem}
                            onDoubleClick={(row) => props.onDoubleClick?.(row)}
                            onSelect={(row) => {
                                setSelectedItem(row ? row : undefined)
                                props.onSelect?.(row ? row : undefined)
                                row ? pluginCtx.masterGrid.onSelectEvent(row, DocumentType.pricingPriceCalcSchemaType) : pluginCtx.masterGrid.onUnselectEvent();
                            }}
                            onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                            onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                            onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                            onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                            onEnter={() => setViewState("edit")}
                            getView={(gridFilter, callback) => {
                                pricingPriceCalcSchemaTypeDP.getView(gridFilter, async (entity) => {
                                    const newCache = new Map(dataCache);
                                    entity.forEach(item => {
                                        newCache.set(item.idGlobal, item);
                                    });
                                    setDataCache(newCache);
                                    setSelectedItem(undefined);
                                    callback(entity);
                                })
                            }}
                        />

                }
                <div >
                    {
                        selectedItem && detailsTabsPanel.tabs.length > 0 &&
                        <div>
                            <div >
                                <div id="detailsTabsPanelWrapper" style={{ position: "relative", overflow: 'hidden', width: '100%' }}>
                                    <TabsPanel
                                        id="detailsTabsPanel"
                                        activeId={detailsTabsPanel.currentTab?.id}
                                        tabs={detailsTabsPanel.tabs}
                                        switchControl
                                        onActive={(tab) => { dispatchDetailsTabsPanel({ type: "activate", payload: tab }) }}>
                                    </TabsPanel>
                                </div>
                            </div>
                            <div >
                                    {detailsTabsPanel.tabs.map(item => {
                                        const isActive = item.id === detailsTabsPanel.currentTab?.id;
                                        return <div
                                            key={item.id}
                                            className={classNames(item.id === detailsTabsPanel.currentTab?.id ? tabsStyles.contentVisible : tabsStyles.contentHidden)}
                                        >
                                            {isActive && React.isValidElement(item.view.content) ? (
                                                React.cloneElement(item.view.content, {
                                                    key: `${item.id}_${selectedItem?.idGlobal}`,
                                                    selectedCalcSchemaTypeObject: selectedCalcSchemaTypeObject
                                                } as any)
                                            ) : (
                                                item.view.content
                                            )}
                                        </div>
                                    })}
                                </div>
                        </div>
                    }
                </div>
            </PluginWrapper>

            {
                modalState.isOpen &&
                <PricingAdpriceScaleTypeCreatorModal
                    data={modalState.modalData}
                    variant={modalState.variant}
                    save={(saveData) => {
                        if (modalState.variant === 'edit') {
                            pricingPriceCalcSchemaTypeDP.update(selectedItem?.idGlobal as string, saveData, () => {
                                setModalState(prev => ({ ...prev, isOpen: false }));
                                getView();
                            });
                        }
                        else {
                            pricingPriceCalcSchemaTypeDP.create(saveData, (idGlobal) => {
                                setModalState(prev => ({ ...prev, isOpen: false }));
                                getView();
                            })
                        }
                    }}
                    cancel={() => setModalState(prev => ({ ...prev, isOpen: false }))}
                />
            }
        </>

    );
};